
  export default {
    mounted() {
      this.updateStates();
    },
    updated() {
      this.updateStates();
    },
    updateStates() {
      const items = this.el.querySelectorAll("[data-spin-streak-item]");

      items.forEach((item) => {
        const input = item.querySelector('input[type="checkbox"]');
        const number = item.querySelector('[data-role="number"]');
        const cross = item.querySelector('[data-role="cross"]');
        if (!input || !number || !cross) return;

        const checked = !!input.checked;

        cross.classList.toggle("hidden", !checked);
     });
    },
  }
